import { string } from 'prop-types';
import React from 'react';

import Typography from 'ravenjs/lib/Typography';

const SidebarHelpText = props => {
    const { helpText } = props;
    return helpText ? (
        <Typography color="sidebarHelpText" type="sidebarHelpText">
            {helpText}
        </Typography>
    ) : null;
};

SidebarHelpText.propTypes = {
    helpText: string,
};

SidebarHelpText.defaultProps = {
    helpText: null,
};

export default SidebarHelpText;
